module.exports = __webpack_public_path__ + "img/fond_random_number_to_letter_generator.e3eb98f9.jpg";